<template>
  <div>
    <el-header>
      <div class="top">
        <div v-if="nav" class="top-nav">
          <a href="/"
            ><img v-if="info" src="@/assets/imgs/logo.png" alt=""
          /></a>
          <!-- <div v-for="(item, index) in nav" :key="index" class="top-nav-title">
            <nuxt-link
              v-if="!isExternalUrl(item.navUrl)"
              :to="{ path: item.navUrl }"
              :class="{ active: activeUrl === item.navUrl }"
            >
              {{ item.navTitle }}
            </nuxt-link>
            <a v-else :href="item.navUrl" :target="item.target">{{
              item.navTitle
            }}</a>
          </div> -->
        </div>
        <ul class="top-nav">
          <router-link
            to="/"
            tag="li"
            active-class="current"
            exact
            class="top-nav-title"
          >
            <a>首页</a>
          </router-link>
          <router-link
            to="/course"
            tag="li"
            active-class="current"
            class="top-nav-title"
          >
            <a>课程</a>
          </router-link>
          <router-link
            to="/teacher"
            tag="li"
            active-class="current"
            class="top-nav-title"
          >
            <a>名师</a>
          </router-link>
          <router-link
            to="/article"
            tag="li"
            active-class="current"
            class="top-nav-title"
          >
            <a>文章</a>
          </router-link>
        </ul>
        <div class="top-user">
          <div v-if="loginStatus">
            <common-user />
          </div>
          <div v-else>
            <nuxt-link :to="{ name: 'login' }"> 登录 </nuxt-link>
            <nuxt-link :to="{ name: 'register' }"> 注册 </nuxt-link>
          </div>
        </div>
      </div>
    </el-header>
    <main>
      <!-- <router-view></router-view> -->
      <div class="tabs-group">
        <ul class="content clearfix" style="margin: 0">
          <li style="padding: 0; width: 9.6%" class="" v-for="(item) in tabsGroup" :key="item" >{{item.title}}</li>
        </ul>
      </div>
    </main>
    <footer>
      <!-- 公共底部内容，例如版权信息、联系方式等 -->
      <p>版权所有 &copy; 2024</p>
      <p>联系我们：example@email.com</p>
    </footer>
  </div>
</template> 

<script>
export default {
  data(){
    return{



    tabsGroup:[
        {
          id: 0,
          title: "药事管理与法规",
        },
             {
          id: 0,
          title: "（中）药学专业知识（一）",
        },
             {
          id: 0,
          title: "（中）药学专业知识（二）",
        },
             {
          id: 0,
          title: "（中）综合知识与技能",
        },
    ],

    }
  },
};
</script>

<style lang="less" scoped>
.el-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: #fff;
  z-index: 999;
  height: 70px;
  display: flex;
  justify-content: center;
  border: 1px solid #ebeef5;
}

.active {
  color: #46c37b;
}

.top {
  width: 1200px;
  height: 70px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  .top-nav {
    display: flex;
    align-items: center;
    .top-nav-title {
      margin-left: 30px;
      font-size: 18px;
    }

    .top-nav-title:last-child {
      border-radius: 10px;
      color: #fff;
      border-color: #46c37b;
      background-color: #46c37b;
      padding: 8px 10px;
    }
  }

  .top-search {
    .el-input {
      height: 35px;
      line-height: 35px;
    }
    img {
      width: 20px;
    }
  }

  .top-user {
    img {
      border-radius: 50%;
    }
    a {
      font-size: 16px;
      margin-left: 10px;
    }
  }

  img {
    height: 35px;
    width: auto;
  }
}
main {
  background: #f7f8fa;
}
</style>
